module.exports = __webpack_public_path__ + "static/media/mihai_bulai.622df680.png";